import React from 'react';
import { Link } from './Link';

/* eslint-disable */

export const Navigation = props => {
  const { classNamePrefix = 'main', links, extraClassNames, MobileNavFooter } = props;
  const className = classNamePrefix ? `${classNamePrefix}-navigation` : 'navigation';
  return (
    <nav className={`${className} ${extraClassNames || ''}`}>
      <div className={`${className}-body`}>
        <div className={`${className}-links`}>
          {links && links.map(link => (
            <Link {...link} key={link.text} className={`${className}-link ${link.className || ''}`}>
              {link.text}
            </Link>
          ))}
        </div>
      </div>
      {MobileNavFooter && <MobileNavFooter />}
    </nav>
  );
};
